module.exports = __webpack_public_path__ + "img/icon-cart-1.ff0839a1.svg";